import { Form, Formik } from 'formik';
import styled from 'styled-components';
import * as yup from 'yup';
import { FARM_ROLES } from '../constants/teamRoles';
import {
  DropdownButtonField,
  SubmitButton,
  ValidatedInput,
} from './templates/template-components';

const emailSchema = yup.object().shape({
  emails: yup
    .array()
    .transform((value, originalValue) => {
      if (Array.isArray(value)) {
        return value;
      }
      return originalValue ? originalValue.split(/[\s,]+/) : [];
    })
    .of(yup.string().email(({ value }) => `${value} is not a valid email`))
    .required('Required'),
  role: yup.string().required('Required'),
});

const EmailContainer = styled.div`
  flex-grow: 1;
`;

const EmailForm = ({
  onSubmit,
  loading,
  roles = FARM_ROLES,
  submitButtonText = 'Send Invite',
}) => {
  return (
    <Formik
      initialValues={{ emails: '', role: roles[0].value }}
      validationSchema={emailSchema}
      onSubmit={({ emails, role }, { resetForm }) => {
        const filteredEmails = emails
          .split(',')
          .filter((email) => email !== '')
          .map((email) => {
            return {
              email: email.replace(/\s/g, ''),
              role: role || 'viewer',
            };
          });
        onSubmit({ emails: filteredEmails }, { resetForm });
      }}
    >
      {({ isSubmitting }) => (
        <Form onKeyDown={(e) => e.code === 'Enter' && e.preventDefault()}>
          <ValidatedInput
            type="text"
            name="emails"
            placeholder="List of emails, comma separated"
          >
            {({ renderInput, renderError }) => (
              <div className="my-3">
                <div className="d-flex justify-content-between align-items-center">
                  <EmailContainer>{renderInput()}</EmailContainer>
                  <DropdownButtonField
                    inModal
                    color="link"
                    options={roles}
                    name="role"
                    className="ml-2"
                  />
                </div>
                {renderError()}
              </div>
            )}
          </ValidatedInput>
          <SubmitButton disabled={isSubmitting || loading}>
            {submitButtonText}
          </SubmitButton>
        </Form>
      )}
    </Formik>
  );
};

export default EmailForm;
